import React from 'react';
import Chip from '@material-ui/core/Chip';

const VisaRequestChips = ({ variant, visaResources }) => {
    return (
        <>
            {
                visaResources.map((resource, index) =>
                    <Chip
                        key={index}
                        size="small"
                        label={resource.visaCountryName}
                        color="secondary"
                        variant={variant}
                    />
                )
            }
        </>
    )
}

export default VisaRequestChips;